import { render, staticRenderFns } from "./MinesGame.vue?vue&type=template&id=5e9c7f6f&scoped=true"
import script from "./MinesGame.vue?vue&type=script&lang=js"
export * from "./MinesGame.vue?vue&type=script&lang=js"
import style0 from "./MinesGame.vue?vue&type=style&index=0&id=5e9c7f6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c7f6f",
  null
  
)

export default component.exports